import React from "react";
import Header from "../../components/header";
import { useNavigate } from "react-router";
import {  Link } from 'carbon-components-react';

const Saved = () => {
  const navigate = useNavigate();
  return (
    <>
    <Header title="Your information has been saved successfully." />
    <p>
    <Link role="button" size="lg" onClick={() => navigate("/")}>Return to Enrollments</Link>
    </p>
    </>
  );
};

export default Saved;
